<div class="template-details" [formGroup]="detailsFormGroup">
  <div class="details-grid">
    <sc-dictionary-field [model]="details.name" [defaultLabel]="'name'" style="grid-column: 1; grid-row: 1;"
      (dictionaryChanged)="onDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template.name'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <mat-form-field style="grid-column: 1; grid-row: 2;" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template.title-pattern"></sc-dictionary-label>
      </mat-label>
      <input matInput name="titlePattern" formControlName="titlePattern"
        [required]="false" [maxLength]="255">
    </mat-form-field>
  </div>
</div>
